export class Constants {
  public static readonly FABRIC = {
    ADD_NODE: {
      RECT: {
        BACKGROUND_COLOR: 'yellow'
      }
    }
  };
  public static readonly USER_ROLE = {
    USER: 'IEPSiteUser',
    ADMIN: 'IEPBoschAdmin',
    TECH_SUPPORT_L1: 'IEPBoschTechSupportL1',
    TECH_SUPPORT_L2: 'IEPBoschTechSupportL2',
    POWER_USER: 'IEPSitePowerUser',
    TECH_SUPPORT_L3: 'IEPBoschTechSupportL3',
    TECH_SUPPORT_L4: 'IEPBoschTechSupportL4',
    TECH_SUPPORT_L5: 'IEPBoschTechSupportL5',
    TECH_SUPPORT_L6: 'IEPBoschTechSupportL6',
    TECH_SUPPORT_L7: 'IEPBoschTechSupportL7',
    SITE_OWNER: 'IEPSiteOwner',
    MULTIPLE_SITE: 'IEPSiteUser',
    SINGLE_SITE: 'IEPTestRole',
    CUSTOM: 'SitePowerUser'
  };
  public static readonly DATE = {
    DATE_FORMAT: 'yyyy-MM-dd',
    DATE_FORMAT_MONTH: 'yyyy-MM',
    INSTANT_DATE_FORMAT: 'yyyy-MM-dd HH:mm:ss',
    INSTANT_DATE_FORMAT_START: 'yyyy-MM-dd 00:00:00',
    INSTANT_DATE_FORMAT_END: 'yyyy-MM-dd 23:59:59',
    HOURS_FORMAT: 'HH:mm:ss'
  };
  public static readonly MOMENT_DATE_FORMAT = {
    DATE_FORMAT: 'YYYY-MM-DD',
    DATE_FORMAT_MONTH: 'YYYY-MM',
    DAY_FORMAT: 'DD-MM-YYYY',
    FULL_DATE_FORMAT: 'DD-MM-YYYY HH:mm:ss',
    FULL_DATE_FORMAT_1: 'YYYY-MM-DD HH:mm:ss',
    FULL_DATE_FORMAT_2: 'DD-MM-YYYY HH:mm:ss',
    FULL_DATE_FORMAT_3: 'DD MMMM YYYY HH:mm:ss',
    FULL_DATE_FORMAT_ZONE: 'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
    HOURS_FORMAT: 'HH:mm:ss',
    HOURS_FORMAT_1: 'HH:mm',
    FULL_DATE_TIME_FORMAT: 'dddd, MMM D, H:mm:ss', // EEEE, MMM d, h:mm:ss
    FULL_DATE_YEAR_TIME_FORMAT: 'dddd, MMM D, YYYY H:mm:ss'
  };
  public static readonly DATE_RANGES_PROVIDER_FORMAT = {
    parse: {
      dateInput: 'YYYY-MM-DD'
    },
    display: {
      dateInput: 'YYYY-MM-DD',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'YYYY-MM-DD',
      monthYearA11yLabel: 'MMMM YYYY'
    }
  };
  public static readonly DECIMAL_FORMAT = {
    DECIMAL_NO: 2,
    SOLAR_DECIMAL_NO: 2,
    SOLAR_RO_DECIMAL_NO: 3,
    SOLAR_RO_COUNTER_DECIMAL_NO: 4
  };
  public static readonly ACTIVITY = {
    NEW_SITE: 'NSC',
    EDIT_SITE: 'ESD',
    VIEW_SITE: 'VSD',
    DELETE_SITE: 'DSD',
    NEW_USER: 'NSUC',
    EDIT_USER: 'ESUD',
    CHANGE_USER_PASSWORD: 'CSP',
    VIEW_USER: 'VSUD',
    VIEW_USER_PASSWORD: 'VSUP',
    DELETE_USER: 'DSU',
    CHANGE_USER_STATUS: 'CSOU',
    NEW_PROCESS: 'NPC',
    EDIT_PROCESS: 'EPD',
    VIEW_PROCESS: 'VPD',
    DELETE_PROCESS: 'DPD',
    NEW_LOAD: 'NLC',
    EDIT_LOAD: 'ELD',
    VIEW_LOAD: 'VLD',
    DELETE_LOAD: 'DL',
    NEW_DASHBOARD: 'NDC',
    EDIT_DASHBOARD: 'EDa',
    VIEW_DASHBOARD: 'VD',
    DELETE_DASHBOARD: 'DDa',
    VIEW_DASHBOARD_MASTER: 'VDaM',
    NEW_LOAD_2: 'NLC2',
    EDIT_LOAD_2: 'ELD2',
    VIEW_LOAD_SITE: 'VLDS',
    VIEW_DASHBOARD_MASTER_2: 'VDaM2',
    DELETE_LOAD_2: 'DL2',
    NEW_INVENTORY: 'NIR',
    EDIT_INVENTORY: 'EI',
    VIEW_INVENTORY: 'VI',
    DELETE_INVENTORY: 'DI',
    VIEW_INVENTORY_MASTER: 'VIM',
    NEW_ROLE: 'NRD',
    EDIT_ROLE: 'ERD',
    VIEW_ROLE_SITE: 'VRDS',
    DELETE_ROLE: 'DRD',
    VIEW_ROLE_MASTER: 'VRDM',
    NEW_DEFINITION: 'ND',
    EDIT_DEFINITION: 'EDe',
    VIEW_DEFINITION_SITE: 'VDS',
    DELETE_DEFINITION: 'DDe',
    VIEW_DEFINITION_MASTER: 'VDeM',
    STRATIFICATION_TANK_VIEW: 'STV',
    HYDRAULIC_UNIT_VIEW: 'HUV',
    TRANSFORMER_MONITORING_VIEW: 'TM',
    SOLAR_DASHBOARD_VIEW: 'SD',
    TESTBENCH_OVERVIEW: 'TO',
    LAYOUT_VIEW: 'LV',
    LOAD_ON_TREE_VIEW: 'LOTV',
    ENERGY_DASHBOARD: 'ED',
    REAL_TIME_INFORMATION: 'RTI',
    DEEP_DIVE_INFORMATION: 'DDI',
    NOTIFICATIONS: 'N',
    METER_VIEW: 'MV',
    LIVE_EQ: 'LEQ',
    SOLAR_RO_IN_DASHBOARD_VIEW: 'SRID',
    GENERIC_FLOW_MANAGEMENT_DASHBOARD: 'GFMD',
    MIS_SERVICE: 'MIS',
    DASHBOARD_OVERVIEW: 'DO',
    UTILITIES: 'UTI',
    KPIBENCHMARKING: 'KPIBEN',
    MACHINEMONITORING: 'MMOR',
    SOLAR_PLANT_OVERVIEW: 'SLPO',
    SOLAR_INVERTER_VIEW: 'SLIV',
    SOLAR_ARCHITECTURE_VIEW: 'SLA',
    SPECIFIC_ENERGY: 'SPE',
    TRANSFORMER_DASHBOARD: 'TRD',
    UNLIMITED_SESSION: 'ULS',
    NO_LOGOUT: 'NL1'
  };
  public static readonly DOCUMENT_TYPE = {
    LOGO: 'Logo',
    LAYOUT: 'Layout',
    LOAD: 'Load',
    SOLAR_LAYOUT: 'Solar_Layout',
    CLICK_AND_NAVIGATE_LAYOUT: 'ClickAndNavigateLayout',
    TREE_NODE_IMAGE: 'TreeNodeImage',
    OTHER: 'Other',
    MIS_SERVICE_LOGO: 'misServiceLogo'
  };
  public static readonly WIDGET = {
    TOP_WIDGET: 'Top Widget',
    LOAD_TREE: 'Load Tree',
    LEFT_PANEL: 'Left Panel',
    LOADING_ANALYSIS: 'Loading Analysis',
    ON_TIME_ANALYSIS: 'On Time Analysis',
    ENERGY_CONSUMPTION_ANALYSIS: 'Energy Consumption Analysis',
    MAINS_POWER_FACTOR: 'Mains Power Factor',
    COMPARISION_ANALYSIS: 'Comparision Analysis',
    PEAK_POWER_ANALYSIS: 'Peak Power Analysis',
    STRATIFICATION_TANK_VIEW: 'Stratification Tank View',
    HYDRAULIC_UNIT_VIEW: 'Hydraulic Unit View',
    TRANSFORMER_MONITORING_VIEW: 'Transformer Monitoring',
    SOLAR_DASHBOARD_VIEW: 'Solar Dashboard',
    SOLAR_RO_VIEW: 'Solar RO',
    TESTBENCH_OVERVIEW: 'TestBench Overview'
  };
  public static readonly LOAD_TYPE = {
    THERMAL: { TYPE_VALUE: 'Thermal' },
    TURNING: {
      TYPE_VALUE: 'Turning',
      SUB_TYPES_VALUE_TEXT: {
        SinglePhase: 'Single Phase Motor',
        ThreePhase: 'Three Phase Motor'
      }
    },
    LIGHTING: {
      TYPE_VALUE: 'Lighting'
    },
    SWITCHING: {
      TYPE_VALUE: 'Switching'
    },
    TRANSFORMER: {
      TYPE_VALUE: 'Transformer'
    },
    GENERIC_OR_AREA_SPECIFIC_SENSOR: {
      TYPE_VALUE: 'GenericSensorLoad'
    }
  };
  public static readonly LOAD_PARAM = {
    ALL_ELECTRICAL: 'electricalParams',
    TEMPERATURE: 'temperature',
    PRESSURE: 'pressure',
    FLOW_OUTPUT: 'flowOutput',
    ALL_HARMONIC: 'harmonicParams',
    ALL_WATER: 'flowParams'
  };
  public static readonly NODE_TYPE = {
    TEXT: 'TEXT',
    METER: 'METER',
    PROCESS: 'PROCESS',
    LOAD: 'LOAD',
    VIRTUAL_GROUP: 'VIRTUAL_GROUP'
  };
  public static readonly SYSTEM_VOLTAGE = {
    kV_765: 765000,
    kV_400: 400000,
    kV_220: 220000,
    kV_132: 132000,
    kV_110: 110000,
    kV_66: 66000,
    kV_33: 33000,
    lessThan33kV: '< 33000'
  };
  public static readonly SHIFTS = [
    'firstshift',
    'secondshift',
    'nightshift',
    'fourthshift'
  ];
  public static readonly IDLE_UTILIZATION = ['utilization', 'idle'];
  public static readonly HYDRAULIC_PARAMETER_TYPE = {
    Energy: 'Energy',
    Power: 'Power',
    Temperature: 'Temperature',
    Pressure: 'Pressure',
    FluidLevel: 'FluidLevel',
    FluidLevel_Litres: 'FluidLevel_Litres',
    EnergyFlow_GJ: 'EnergyFlow_GJ',
    FlowRate_LitrePerMin: 'FlowRate_LitrePerMin',
    FlowRate_cubicMeter: 'FlowRate_cubicMeter',
    FlowRate: 'FlowRate',
    FlowRateTotal: 'FlowRateTotal',
    FlowRateTotal_SCF: 'FlowRateTotal_SCF',
    FlowRate_cubicMeterPerHour: 'FlowRate_cubicMeterPerHour',
    Velocity_meterPerSecond: 'Velocity_meterPerSecond',
    LimitSwitch: 'LimitSwitch',
    FilterStatus: 'FilterStatus',
    Cleanliness: 'Cleanliness',
    RH: 'RH',
    BTU: 'BTU',
    RPM: 'RPM',
    Voltage: 'Voltage',
    Percentage: 'Percentage',
    Vibration: 'Vibration',
    FlowRate_KilogramPerHour: 'FlowRate_KilogramPerHour',
    FlowRateTotal_Kilogram: 'FlowRateTotal_Kilogram',
    FlowRate_milligramPerLitre: 'FlowRate_milligramPerLitre',
    Vibration_millimeterPerSecond: 'Vibration_millimeterPerSecond',
    Pressure_millimeterPerWaterColumn: 'Pressure_millimeterPerWaterColumn',
    FlowRate_tonnPerHour: 'FlowRate_tonnPerHour',
    FlowRateTotal_tonn: 'FlowRateTotal_tonn',
    Conductivity: 'Conductivity',
    Frequency: 'Frequency'
  };
  public static readonly ALERT_FOR_TYPE = {
    SOLAR: 'Solar',
    OTHER: 'Other'
  };
  public static readonly HYDRAULIC_OUTPUT_TYPE = {
    Modbus: 'Modbus',
    Switch: 'Switch',
    AnalogVoltage: 'Analog Voltage',
    AnalogCurrent: 'Analog Current'
  };
  public static readonly MESSAGE = {
    AddSuccessMess: 'Add new record successfuly',
    DeleteSuccessMess: 'Delete record successfuly',
    EditSuccessMess: 'Update record successfuly',
    SavingErrorMess: 'Error while saving data',
    GettingErrorMess: 'Error while getting data',
    DeletingErrorMess: 'Error while deleting data',
    LoginFail: 'Login fail.',
    PostingErrorMess: 'Error while sending data',
    Save_success: 'Save successfuly',
    Save_failure: 'Save fail. Please try later.',
    Delete_success: 'Delete successfuly',
    Delete_failure: 'Delete fail. Please try later.',
    Delete_Confirm: 'Are you sure to delete?',
    Delete_Alerts: 'Are you sure to delete the Alerts from Database?'
  };
  public static readonly SENSOR_HEALTH = {
    ON: 'ON',
    OFF: 'OFF',
    NA: 'NA',
    OK: 'OK',
    NOT_OK: 'NOT OK'
  };
  public static readonly MACHINE = {
    Label_Machine_ON: 'label-machine-ON',
    Label_Machine_OFF: 'label-machine-OFF',
    Label_Data_NA: 'label-data-NA'
  };
  public static readonly INVERTER_STATUS = {
    OK: 'OK',
    Faulty: 'Faulty',
    NA: 'NA'
  };
  public static readonly TIMEBASE_ARRAY = [
    { value: 'Y', viewValue: 'Yearly' },
    { value: 'M', viewValue: 'Monthly' },
    { value: 'Q', viewValue: 'Quarterly' },
    { value: 'W', viewValue: 'Weekly' },
    { value: 'D', viewValue: 'Daily' }
  ];
  public static BOOLEAN_FALSE = false;
  public static BOOLEAN_TRUE = true;
  public static NULL_VALUE = null;
  public static one = '1';
  public static two = '2';
  public static three = '3';
  public static four = '4';
  public static FAIL = 'Fail';
  public static SUCCESS = 'Success';
  public static FUTURE_DATE_NOT_ALLOW = 'Future date is not allowed!';
  public static OPERATORS = [
    { value: '=', text: 'Equal to' },
    { value: '!=', text: 'Not Equal to' },
    { value: '>', text: 'Greater Than' },
    { value: '<', text: 'Less Than' },
    { value: '>=', text: 'Greater Than or equal to' },
    { value: '<=', text: 'Less Than or equal to' }
  ];
  public static FREQUENCIES = [
    { value: 1, text: "First Ocurrance and It's End" },
    { value: 2, text: "At Every Ocurrance and It's End" },
    { value: 3, text: 'After Every End' }
  ];
  criticalityLevels = ['Informative', 'Critical', 'Very Critical'];

  public static LOCALE = {
    'America/New_York': 'en-US',
    'Asia/Calcutta': 'en-IN',
    'Asia/Tokyo': 'ja-JP',
    'Europe/Berlin': 'de-DE',
    'Europe/London': 'en-GB'
  };

  public static CURRENCIES = ['EUR', 'GBP', 'INR', 'JPY', 'USD'];
}
